export default {
  props: {
    site: Object
  },
  mounted() {
    if (this.model?.__syncWidget) {
      this.$widgetReady()
    }
  },
  methods: {
    $widgetReady() {
      this.$nextTick(() => {
        const tracker = this.site?.__widgetReadyTracker
        const widgetId = this.model?.id
        if (tracker && widgetId) {
          tracker.ready(widgetId)
        }
      })
    }
  }
}